import axios from 'axios';
import connAxios from "./Conn"

//const USER_API_BASE_URL = 'http://localhost:8080';
const USER_API_BASE_URL = process.env.REACT_APP_API_ENDPOINT + '/pet';

let config = {
    headers: {
      "Content-Type": "application/json",
      'Access-Control-Allow-Origin': '*',
      }
}


class Pet {

    fetchPets() {
        return connAxios.get(USER_API_BASE_URL+'/listAll');
    }

    fetchPetsByCustomer(customerId) {
        return connAxios.get(USER_API_BASE_URL+'/listAll/'+ customerId);
    }

    fetchPetById(cityId) {
        return connAxios.get(USER_API_BASE_URL + '/' + cityId);
    }

    deletePet(cityId) {
        return connAxios.put(USER_API_BASE_URL + '/update',cityId);
    }

    addPet(pet) {
        return connAxios.post(USER_API_BASE_URL+'/add', pet);
    }

    editPet(city) {
        return connAxios.put(USER_API_BASE_URL + '/update', city);
    }


}

export default new Pet();